// secPose v2 helpers.
//
// Platform secPose always runs as v2: synthesize blank per-side prediction
// files from sampled image IDs so the parser, store, and serializer keep one
// schema path. Actual starting positions are supplied by useCarryForwardSeed.

import { KEYPOINTS } from '../../config/keypoints';
import type { NewKeypointRaw, NewPredictionsFile } from '../../types';

const DEFAULT_FPS = 30;
const DEFAULT_IMAGE_SIZE: [number, number] = [1, 1];

export function buildNullPredictions(
  frameIndices: number[],
  imageSize: [number, number] = DEFAULT_IMAGE_SIZE,
  fps: number = DEFAULT_FPS
): NewPredictionsFile {
  const frames: NewPredictionsFile['frames'] = {};
  for (const idx of frameIndices) {
    const frame: Record<string, NewKeypointRaw> = {};
    for (const { name } of KEYPOINTS) {
      frame[name] = { pixel_coords: null, confidence_score: 0, status: null };
    }
    frames[String(idx).padStart(6, '0')] = frame;
  }
  const maxIdx = frameIndices.length > 0 ? Math.max(...frameIndices) : 0;
  return {
    metadata: {
      image_size: imageSize,
      number_of_frames: maxIdx + 1,
      fps,
      support_keypoints: KEYPOINTS.map((k) => k.name),
      frame_image_extension: '.jpg',
    },
    frames,
  };
}
